export default __webpack_public_path__ + "static/media/codeigniter.09a9044d.svg";